import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalEntries: number;
  entriesLimit: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalEntries,
  entriesLimit,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalEntries / entriesLimit) || 1;
  const startEntry = totalEntries === 0 ? 0 : (currentPage - 1) * entriesLimit + 1;
  const endEntry = Math.min(totalEntries, currentPage * entriesLimit);

  return (
    <div className="px-6 py-4 bg-white border-t border-gray-200 flex items-center justify-between text-xs font-semibold">
      <div className='text-[#6C757D] font-normal'>
        Showing {startEntry} to {endEntry} of {totalEntries} entries
      </div>
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          className="px-4 py-2 bg-[#FFF8E1] rounded-xl go_erp-text disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer "
          disabled={currentPage === 1}
        >
          Prev
        </button>
        <button type="button" className="w-6 h-6 go_erp-bg text-white rounded-full border go_erp-border">
          {currentPage}
        </button>
        <button
          type="button"
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          className="px-3 py-2 bg-[#FFF8E1] rounded-xl go_erp-text disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
          disabled={currentPage >= totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
